import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams, useLocation, useSearchParams } from 'react-router-dom'
import { Card, CardBody, CardFooter, CardTitle, Col, Container, Modal, Nav, NavItem, NavLink, Offcanvas, OffcanvasBody, OffcanvasHeader, Row, TabContent, TabPane } from 'reactstrap'
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model'
import CommonService from 'services/CommonService'
import { ID_EncryptionKey, currencyByCountry, getLocalStorage, getStatusIds, getUserLanguage, isMobile, isValidUser, isValidUserAuthenticateForSeo, toAmount } from '../../helpers/Helper'
import { HelperConstant } from '../../helpers/HelperConstant'
import html2pdf from 'html2pdf.js';
import AssigneInfo from './AssigneInfo'
import CustomerInfo from './CustomerInfo'
import Questionarie from './Questionarie'
import { getDecodedAccessToken, isRider } from '../../helpers/TokenHelper'
import { CustomButton } from 'components/shared/CustomButton'
import OrderDocumentInfo from './OrderDocumentInfo'
import { IOrderHistory } from 'models/IOrderHistory.Model'
import moment from 'moment'
import CancelOrder from './CancelOrder'
import Template from './Template'
import CustomLoader from 'components/Common/CustomLoader'
import SimpleBar from 'simplebar-react'
import ResendToCustomer from './ResendToCustomer'
import EnquiryServices from 'services/Enquiry.Services'
import { Capacitor } from '@capacitor/core'
import { LocalNotifications, ScheduleOptions } from '@capacitor/local-notifications'
import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener'
import { Filesystem, Directory, WriteFileResult } from '@capacitor/filesystem'
import SellService from 'services/Sell.Service'
import FileSaver from 'file-saver';

var CryptoJS = require("crypto-js");

function AgentTicketView() {
    document.title = "Order Summary | DOFY-Admin";
    const ref = useRef(null)


    const { encryptedId } = useParams<any>();
    const [searchParams] = useSearchParams();
    const dashboardStatusId = searchParams.get('dashboardStatusId') as any;
    const navigate = useNavigate();
    const [activeTab, setactiveTab] = useState<any>(1)
    const [orderSummaryInfo, setOrderSummaryInfo] = useState<IGetOrderSummaryModel>();
    const [showEdit, setShowEdit] = useState(true);
    const [showReschedule, setShowReschedule] = useState<boolean>(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalInvoice, setShowModalInvoice] = useState(false);
    const [isCancel, setIsCancel] = useState(false);
    const [showActionSheet, setShowActionSheet] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    const [load, setLoad] = useState<boolean>(false);
    const [segmentValue, setSegmentValue] = useState<Array<any>>([]);
    const [customTab, setcustomTab] = useState<Array<any>>([]);
    const [statusCanvas, setStatusCanvas] = useState<boolean>(false);
    const [isResendOpen, setIsResendOpen] = useState(false);
    const [userAddressId, setUserAddressId] = useState<number>(0);

    const languageCode = localStorage.getItem("LanguageCode");
    const countryCode = localStorage.getItem("CountryCode");

    const pendingIds = `${HelperConstant.StatusId.PENDING},${HelperConstant.StatusId.PUBLICRECALCULATION},${HelperConstant.StatusId.ADMINCRECALCULATION}`;

    // //For AES Decryption
    // let wordArrays = CryptoJS.enc.Hex.parse(encryptedId)
    // let base64String = CryptoJS.enc.Base64.stringify(wordArrays)
    // var bytes = CryptoJS.AES.decrypt(base64String, ID_EncryptionKey, { keySize: 128, iv: ID_EncryptionKey, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    // var decryptedId = bytes.toString(CryptoJS.enc.Utf8);
    const riderlogin: boolean = isRider() ?? false;

    const segmentTile = [{
        id: 1,
        name: 'Customer Info',
        value: 'customer',
        icon: 'mdi mdi-account-details',
        canShow: true
    },
    {
        id: 2,
        name: 'Rider Info',
        value: 'rider',
        icon: 'mdi mdi-bike-fast',
        canShow: !riderlogin
    },
    {
        id: 3,
        name: orderSummaryInfo?.ServiceTypeId === HelperConstant.serviceTypeId.SELL ? "Device Info" : "Parts Info",
        value: 'device',
        icon: 'mdi mdi-devices',
        canShow: true

    },
    {
        id: 4,
        name: "Document Info",
        value: 'document',
        icon: 'mdi mdi-file-check',
        canShow: true

    }
    ];

    const toggleStatusCanvas = () => {
        setStatusCanvas(!statusCanvas)
    }

    const SegmentHandler = (id) => {
        setactiveTab(id);
    }

    const RetrieveOrder = (orderId: any) => {
        // if (orderSummaryInfo?.StatusId === HelperConstant.StatusId.PENDING) {
        //     window.location.href = "/order-schedule/" + encryptedId;
        // }
        // else {
        //     navigate(`/order-schedule/${encryptedId}`)
        // }
        window.location.href = "/order-schedule/" + encryptedId + "?dashboardStatusId=" + dashboardStatusId;

    }

    const ScheduleOrder = (orderId: any) => {
        window.location.href = "/order-schedule/" + encryptedId;
    }

    const continuebtn = () => {
        window.location.href = "/final-documents-verify/" + encryptedId;
    }

    const homebtn = () => {
        window.location.href = '/homepage';

    }

    const backbtn = () => {
        // window.close();
        window.location.href = `/dashboard/${dashboardStatusId}`;
    }

    const RequotePage = () => {
        if (orderSummaryInfo?.ServiceTypeId === HelperConstant.serviceTypeId.SELL) {
            window.location.href = '/re-quote/' + encryptedId + "?dashboardStatusId=" + dashboardStatusId;
        }
        // else {
        //     window.location.href = '/repair-requote/' + encryptedId;
        // }
    }

    const GetOrderSummary = () => {
        setShowLoading(true);
        CommonService.getWithSingleEntity('sell', 'GetOrderSummary', encryptedId).then(res => {
            if (res.status === 200) {
                let data = res.data as IGetOrderSummaryModel;
                setOrderSummaryInfo(data);
                setUserAddressId(data.Appointment?.UserAddresId)
                let reschedule = data?.StatusId !== HelperConstant.StatusId.COMPLETED && data?.StatusId !== HelperConstant.StatusId.FAILED && data?.StatusId !== HelperConstant.StatusId.CANCELLED && data?.StatusId !== HelperConstant.StatusId.CANCEL_REQUEST && data?.StatusId !== HelperConstant.StatusId.PENDING ? true : false;
                setShowReschedule(reschedule);
                if (data?.StatusId === HelperConstant.StatusId.CANCELLED || data?.StatusId === HelperConstant.StatusId.COMPLETED
                    || data?.StatusId === HelperConstant.StatusId.FAILED || data?.StatusId === HelperConstant.StatusId.CANCEL_REQUEST || data?.StatusId === HelperConstant.StatusId.RETURN) {
                    setShowEdit(false);
                }
                setShowLoading(false);
            }
        })
    }

    const AdminReEvaluteOrder = () => {
        setShowLoading(true);
        EnquiryServices.AdminReEvaluteOrder(encryptedId).then(res => {
            if (res.status === 200) {
                let data = res.data as IGetOrderSummaryModel;
                setOrderSummaryInfo(data);
            }
            setShowLoading(false);
        }).catch(e => console.error(e))
    }

    const reRender = (load) => {
        setLoad(load);
    }

    const cancelPopup = () => {
        setShowModal(true);
        setIsCancel(true);
    }

    const RejectPopup = () => {
        setShowModal(true);
        setIsCancel(false);

    }
    const invoiceCancel = () => {
        setShowModalInvoice(false);

    }

    const toggleCustom = (tab: any) => {
        // if (activeTab !== tab) {
        setactiveTab(tab);
        // }
    };
    const dancingIcon = (index) => {
        const value = orderSummaryInfo?.OrderHistoryList.findIndex((x, i) => i !== index);
        return value

    }
    const filerSegmentTile = () => {
        if (orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PendingOrders) {
            const filterSegmentTile = segmentTile.filter(x => x.id !== 4);
            setcustomTab(filterSegmentTile);
        } else {
            setcustomTab(segmentTile)
        }
    }

    const downloadPDF = () => {
        setShowModalInvoice(true);
        const element = document.getElementById('content'); // 'content' is the id of the HTML element you want to convert
        const options = {
            filename: 'invoice.pdf' // Specify the filename here
        };
        html2pdf().from(element).set(options).save();
    };


    const downloadMobileInvoice = async (file: any, path: any) => {
        Filesystem.writeFile({
            path: path,
            data: file,
            directory: Directory.Documents,
            recursive: true
        }).then((res: WriteFileResult) => {
            showInvoiceNotification(res.uri, path);
        }).catch(e => console.log(e));
    };

    const openDownloadedFile = async (uri: any) => {
        try {
            const fileOpenerOptions: FileOpenerOptions = {
                filePath: uri,
                openWithDefault: true,
            };
            await FileOpener.open(fileOpenerOptions);

        } catch (e) {
            console.log('Error opening file', e);
        }
    };

    const showInvoiceNotification = async (uri: any, name: any) => {
        let options: ScheduleOptions = {
            notifications: [
                {
                    id: 1,
                    title: name,
                    body: "Download completed. File saved in Documents",
                    extra: { uri: uri },
                    actionTypeId: "open_pdf"
                }
            ]
        };

        try {
            await LocalNotifications.schedule(options);
        } catch (error) {
            console.log(error);
        }

        LocalNotifications.addListener('localNotificationActionPerformed', async (notification) => {
            if (notification.notification.actionTypeId === 'open_pdf') {
                const uri = notification.notification.extra.uri;
                openDownloadedFile(uri);
            }
        });
    }

    const DownloadOrderInvoiceWithDocuments = async (Id: any, OrderCode: any) => {
        setShowLoading(true)
        SellService.DownloadOrderInvoiceWithDocuments(Id, orderSummaryInfo?.QuestionnaireResponse[0].Version, languageCode, countryCode).then(response => {
            if (response.status === 200) {
                if (Capacitor.isNativePlatform()) {
                    let concatedBase64 = "data:application/pdf;base64, " + response.data;
                    downloadMobileInvoice(concatedBase64, `DOFY_Order_Detail_${OrderCode}.pdf`);
                }
                else {
                    let stringWithQuotes = response.data;
                    let stringWithoutQuotes = stringWithQuotes.replace(/"/g, '');
                    const byteArray = Uint8Array.from(atob(stringWithoutQuotes).split('').map(char => char.charCodeAt(0)));
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const file = new File([blob], `DOFY_Order_Detail_${OrderCode}.pdf`, { type: 'application/pdf' });
                    FileSaver.saveAs(file);
                }
                setShowLoading(false)
            }
        }).catch((e) => {
            console.log(e);
        });
    }

    const GetOrderInvoice = async (Id: any, OrderCode: any) => {
        setShowLoading(true);
        SellService.GetOrderInvoice(Id, languageCode, countryCode).then(response => {
            if (response.status === 200) {
                if (Capacitor.isNativePlatform()) {
                    let concatedBase64 = "data:application/pdf;base64, " + response.data;
                    downloadMobileInvoice(concatedBase64, `DOFY_Invoice_${OrderCode}.pdf`);
                }
                else {
                    let stringWithQuotes = response.data;
                    let stringWithoutQuotes = stringWithQuotes.replace(/"/g, '');
                    const byteArray = Uint8Array.from(atob(stringWithoutQuotes).split('').map(char => char.charCodeAt(0)));
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const file = new File([blob], `DOFY_Invoice_${OrderCode}.pdf`, { type: 'application/pdf' });
                    FileSaver.saveAs(file);
                }
                setShowLoading(false)
            }
        }).catch((e) => {
            console.log(e);
        });
    }
    useEffect(() => {
        isValidUser(getDecodedAccessToken(getLocalStorage().Token));
        isValidUserAuthenticateForSeo(getDecodedAccessToken(getLocalStorage().Token));
    }, []);

    useEffect(() => {
        if (getStatusIds(parseInt(dashboardStatusId)) == pendingIds) {
            AdminReEvaluteOrder()
        } else {
            GetOrderSummary();
        }
    }, [load]);

    useEffect(() => {
        setLoad(load);
    }, [load]);

    useEffect(() => {
        filerSegmentTile();
    }, [load])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>Order Summary</h5>
                    </div>
                    {!isMobile() ?
                        <div className='mb-2'>
                            <Row>
                                <Col className='d-flex  justify-content-end'>
                                    {(orderSummaryInfo?.StatusId == HelperConstant.StatusId.COMPLETED && !riderlogin) ?
                                        <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-warning'} iconClasssName={undefined}
                                            name={'Return To Customer'} onClick={() => setIsResendOpen(true)}></CustomButton> : null}
                                    {orderSummaryInfo?.StatusId == HelperConstant.StatusId.COMPLETED ?
                                        <CustomButton type={'button'} btnClassName={'btn-success mx-1'} iconClasssName={undefined}
                                            name={'Download Invoice'} onClick={() => GetOrderInvoice(orderSummaryInfo.EncryptedId, orderSummaryInfo.OrderCode)} ></CustomButton> : null}
                                    {orderSummaryInfo?.StatusId == HelperConstant.StatusId.COMPLETED ?
                                        <CustomButton type={'button'} btnClassName={'btn-dark mx-1 '} iconClasssName={undefined}
                                            name={'Download Order Detail'} onClick={() => DownloadOrderInvoiceWithDocuments(encryptedId, orderSummaryInfo.OrderCode)} ></CustomButton> : null}
                                    <CustomButton type={'button'} btnClassName={'mx-2'} iconClasssName={undefined} name={'Back'} onClick={backbtn}></CustomButton>
                                    {showEdit && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.PUBLICRECALCULATION && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.ADMINCRECALCULATION && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.PENDING && orderSummaryInfo?.AssigneeDetails?.Id > 0 &&
                                        <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-dark'} iconClasssName={'far fa-edit font-size-14 align-middle me-2'} name={'Re-Quote'} onClick={RequotePage} />}
                                    {orderSummaryInfo?.StatusId === HelperConstant.StatusId.CANCEL_REQUEST ?
                                        <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-danger'} iconClasssName={'fas fa-times-circle font-size-14 align-middle me-2'} name={'Cancel Order'} onClick={() => cancelPopup()} /> :
                                        showEdit && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.PENDING && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.PUBLICRECALCULATION && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.ADMINCRECALCULATION ?
                                            <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-danger'} iconClasssName={'fas fa-times-circle font-size-14 align-middle me-2'} name={'Fail'} onClick={() => RejectPopup()} /> : null}
                                    {showReschedule && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN ?
                                        <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-info '} iconClasssName={'fas fa-business-time font-size-14 align-middle me-2'} name={'Re-Schedule'} onClick={() => setIsAlertOpen(true)} /> : null}

                                    {(orderSummaryInfo?.StatusId === HelperConstant.StatusId.CANCEL_REQUEST || orderSummaryInfo?.StatusId === HelperConstant.StatusId.CANCELLED || orderSummaryInfo?.StatusId === HelperConstant.StatusId.FAILED || orderSummaryInfo?.StatusId === HelperConstant.StatusId.PENDING || orderSummaryInfo?.StatusId == HelperConstant.StatusId.PUBLICRECALCULATION || orderSummaryInfo?.StatusId == HelperConstant.StatusId.ADMINCRECALCULATION) && orderSummaryInfo.IsUserActive && !riderlogin ?
                                        <CustomButton type={'button'} btnClassName={'mx-1 btn-success'} iconClasssName={'far fa-check-circle font-size-14 align-middle me-2'} name={'Retrieve'} onClick={() => RetrieveOrder(orderSummaryInfo?.Id)}> </CustomButton> :
                                        <>
                                            {
                                                (orderSummaryInfo?.AssigneeDetails && orderSummaryInfo?.AssigneeDetails?.Id > 0 && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.FAILED
                                                    && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.CANCELLED && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.COMPLETED && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN) ?
                                                    <CustomButton type={'button'} btnClassName={'mx-1 btn-success'} iconClasssName={'far fa-check-circle font-size-14 align-middle me-2'} name={'Continue'} onClick={continuebtn} /> : null}
                                        </>

                                    }
                                </Col>
                            </Row>
                        </div> : null}
                    <Row>
                        <Col lg={12}>
                            <Card className='p-0' style={{ borderLeft: orderSummaryInfo?.IsScheduleByTelecaller ? "3px solid #f1b44c" : "unset" }}>
                                <CardBody>
                                    <Row>
                                        <Col className='d-flex justify-content-between'>
                                            <div>
                                                <CardTitle className="h4">Order Details <span className="text-primary m-0">#{orderSummaryInfo?.OrderCode || ""}</span></CardTitle>
                                                <p className="card-title-desc">Your order is on its way!</p>
                                            </div>
                                            <div>
                                                <i className='bx bxs-dock-right text-dofy font-size-22 cursor-pointer' onClick={toggleStatusCanvas}></i>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Nav tabs className="nav-tabs-custom nav-justified">
                                        {((orderSummaryInfo?.StatusName == HelperConstant.orderStatus.PendingOrders || orderSummaryInfo?.StatusName == HelperConstant.orderStatus.PublicRecalculation || orderSummaryInfo?.StatusId == HelperConstant.StatusId.ADMINCRECALCULATION) ? segmentTile.filter(x => x.id !== 4 && x.id !== 2) : segmentTile).filter(info => info.canShow).map((val, idx) => (
                                            <NavItem key={idx} style={activeTab == val.id ? { backgroundColor: "#1E4496", borderRadius: '6px' } : { backgroundColor: '#FFF', borderRadius: '6px' }} onClick={() => {
                                                toggleCustom(val.id);
                                            }}>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={`${activeTab == val.id ? "text-light" : "text-dofy"}`}>
                                                    <span className="d-block d-sm-none">
                                                        <i className={`dofy-admin-font-lg m-0 ${val.icon}`}></i>
                                                    </span>
                                                    <span className="d-none d-sm-block">{val.name}</span>
                                                </NavLink>
                                            </NavItem>
                                        ))}
                                    </Nav>
                                    <CustomLoader isOpen={showLoading} />
                                    <div>
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId={1}>
                                                <CustomerInfo orderSummaryInfo={orderSummaryInfo} showEdit={showEdit} />
                                            </TabPane>
                                            {(orderSummaryInfo?.StatusName == HelperConstant.orderStatus.PendingOrders || orderSummaryInfo?.StatusName == HelperConstant.orderStatus.PublicRecalculation || orderSummaryInfo?.StatusId == HelperConstant.StatusId.ADMINCRECALCULATION) ? null :
                                                <TabPane tabId={2} >
                                                    <AssigneInfo orderSummaryInfo={orderSummaryInfo} orderId={encryptedId} reRender={reRender} showEdit={showEdit} />
                                                </TabPane>}
                                            <TabPane tabId={3} >
                                                <Questionarie orderSummaryInfo={orderSummaryInfo} />
                                            </TabPane>
                                            {(orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PendingOrders || orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PublicRecalculation || orderSummaryInfo?.StatusId == HelperConstant.StatusId.ADMINCRECALCULATION) ? null :
                                                <TabPane tabId={4} >
                                                    <OrderDocumentInfo encryptedId={encryptedId} ProductTypeName={orderSummaryInfo?.ProductTypeName} statusId={orderSummaryInfo?.StatusId} />
                                                </TabPane>}
                                        </TabContent>
                                    </div>
                                </CardBody>
                                {isMobile() &&
                                    <CardFooter className="bg-transparent border-top">
                                        <Row className="justify-content-center">
                                            {(showEdit && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.PUBLICRECALCULATION && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.ADMINCRECALCULATION && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.PENDING && orderSummaryInfo?.AssigneeDetails?.Id > 0) &&
                                                <Col className="text-center" xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <div onClick={RequotePage}>
                                                        <i className="bx bx-analyse text-dofy dofy-admin-font-lg " />
                                                        <p className='dofy-admin-font-sm m-0  fw-light'>Re-Quote</p>
                                                    </div>
                                                </Col>}
                                            {orderSummaryInfo?.StatusId === HelperConstant.StatusId.CANCEL_REQUEST ?
                                                <Col className="text-center" xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <div onClick={() => cancelPopup()}>
                                                        <i className="bx bx-x-circle dofy-admin-font-lg text-dofy" />
                                                        <p className='dofy-admin-font-sm m-0  fw-light'>Cancel Order</p>
                                                    </div>
                                                </Col>
                                                : (showEdit && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.PENDING && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.PUBLICRECALCULATION && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.ADMINCRECALCULATION) ?
                                                    <Col className="text-center" xl={4} lg={4} md={4} sm={4} xs={4}>
                                                        <div onClick={() => RejectPopup()}>
                                                            <i className="bx bx-x-circle dofy-admin-font-lg text-dofy" />
                                                            <p className='dofy-admin-font-sm m-0  fw-light'>Fail</p>
                                                        </div>
                                                    </Col> : null}
                                            {(showReschedule && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN) &&
                                                <Col className="text-center" xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <div onClick={() => setIsAlertOpen(true)} >
                                                        <i className="bx bx-time dofy-admin-font-lg text-dofy" />
                                                        <p className='dofy-admin-font-sm m-0 fw-light'>Re-Schedule</p>
                                                    </div>

                                                </Col>}

                                            {(orderSummaryInfo?.StatusId == HelperConstant.StatusId.COMPLETED) &&
                                                <Col className="text-center" xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <div onClick={() => GetOrderInvoice(orderSummaryInfo.EncryptedId, orderSummaryInfo.OrderCode)} >
                                                        <i className="bx bx-down-arrow-circle dofy-admin-font-lg text-dofy" />
                                                        <p className='dofy-admin-font-sm m-0 fw-light'>Download Invoice</p>
                                                    </div>

                                                </Col>}
                                            {(orderSummaryInfo?.StatusId == HelperConstant.StatusId.COMPLETED) &&
                                                <Col className="text-center" xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <div onClick={() => DownloadOrderInvoiceWithDocuments(encryptedId, orderSummaryInfo.OrderCode)} >
                                                        <i className="bx bxs-file dofy-admin-font-lg text-dofy" />
                                                        <p className='dofy-admin-font-sm m-0 fw-light'>Dowload Order Details</p>
                                                    </div>

                                                </Col>}
                                            {(orderSummaryInfo?.StatusId == HelperConstant.StatusId.COMPLETED && !riderlogin) &&
                                                <Col className="text-center" xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <div onClick={() => setIsResendOpen(true)} >
                                                        <i className="bx bx-rotate-left dofy-admin-font-lg text-dofy" />
                                                        <p className='dofy-admin-font-sm m-0 fw-light'>Return To Customer</p>
                                                    </div>

                                                </Col>}
                                        </Row>
                                    </CardFooter>}
                            </Card>
                        </Col>
                    </Row>
                    {isMobile() ? <Row>
                        <Col className='d-flex flex-row gap-3'>
                            {/* {orderSummaryInfo?.StatusId == HelperConstant.StatusId.COMPLETED ?
                                <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-warning'} iconClasssName={undefined}
                                    name={'Return To Customer'} onClick={() => setIsResendOpen(true)}></CustomButton> : null} */}
                            <CustomButton type={'button'} btnClassName={'btn-soft-secondary btn-lg mb-2'} iconClasssName={undefined} name={'Back'} onClick={backbtn}></CustomButton>
                            {/* {showEdit &&
                                <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-dark mb-2'} iconClasssName={'far fa-edit font-size-14 align-middle me-2'} name={'Re-Quote'} onClick={RequotePage} />}
                            {orderSummaryInfo?.StatusId === HelperConstant.StatusId.CANCEL_REQUEST ?
                                <CustomButton type={undefined} btnClassName={'mx-1 btn-soft-danger mb-2'} iconClasssName={'fas fa-times-circle font-size-14 align-middle me-2'} name={'Cancel Order'} onClick={() => cancelPopup()} /> : showEdit ?
                                    <CustomButton type={undefined} btnClassName={'mx-1 btn-soft-danger  mb-2'} iconClasssName={'fas fa-times-circle font-size-14 align-middle me-2'} name={'Fail'} onClick={() => RejectPopup()} /> : null}
                            {showReschedule ?
                                <CustomButton type={undefined} btnClassName={'mx-1 btn-soft-info  mb-2'} iconClasssName={'fas fa-business-time font-size-14 align-middle me-2'} name={'Re-Schedule'} onClick={() => setIsAlertOpen(true)} /> : null} */}
                            {(!riderlogin && (orderSummaryInfo?.StatusId === HelperConstant.StatusId.CANCEL_REQUEST || orderSummaryInfo?.StatusId === HelperConstant.StatusId.CANCELLED || orderSummaryInfo?.StatusId === HelperConstant.StatusId.FAILED || orderSummaryInfo?.StatusId === HelperConstant.StatusId.PENDING || orderSummaryInfo?.StatusId == HelperConstant.StatusId.PUBLICRECALCULATION || orderSummaryInfo?.StatusId == HelperConstant.StatusId.ADMINCRECALCULATION) && orderSummaryInfo.IsUserActive) ?
                                (<CustomButton type={undefined} btnClassName={'btn-success btn-lg mb-2 w-xl'} iconClasssName={'far fa-check-circle font-size-14 align-middle me-2'} name={'Retrieve'} onClick={() => RetrieveOrder(orderSummaryInfo?.Id)}> </CustomButton>) : (
                                    <>
                                        {
                                            (orderSummaryInfo?.AssigneeDetails && orderSummaryInfo?.AssigneeDetails?.Id > 0 && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.FAILED
                                                && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.CANCELLED && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.COMPLETED && orderSummaryInfo?.StatusId !== HelperConstant.StatusId.RETURN) && (
                                                <CustomButton type={undefined} btnClassName={'btn-success btn-lg mb-2 w-md'} iconClasssName={'far fa-check-circle font-size-14 align-middle me-2'} name={'Continue'} onClick={continuebtn} />)}
                                    </>
                                )}
                        </Col>
                    </Row> : null}
                    <Modal isOpen={isAlertOpen} size="sm">
                        <div className='modal-content'>
                            <div className='modal-body text-center'>
                                <i className='dripicons-information fs-1 fw-bold text-info mb-0'></i>
                                {/* <p className='fw-bold font-size-18 mb-0'>Are you sure? </p> */}
                                <p className='text-muted fw-semibold font-size-14 my-1'>Are you sure to reschedule this order?</p>
                                <div className="mt-3 d-flex justify-content-end">
                                    <CustomButton
                                        type="button"
                                        btnClassName="ms-2 btn-soft-secondary w-xs me-2 ms-2"
                                        iconClasssName="mdi mdi-close"
                                        name=""
                                        onClick={() => setIsAlertOpen(false)}

                                    />
                                    <CustomButton
                                        type="button"
                                        btnClassName=" btn btn-success w-xs"
                                        iconClasssName=""
                                        name="Re-Schedule"
                                        onClick={() => navigate(`/re-schedule/${encryptedId}`)}

                                    />
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal isOpen={showModalInvoice} size='lg' centered>
                        <Row className='p-2 text-end'>
                            <Col xl={12} className='text-dofy'>
                                <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-dark'} iconClasssName={'bx bx-receipt font-size-14 align-middle me-2'} name={'Invoice'} onClick={downloadPDF} />
                                <CustomButton type={'button'} btnClassName={'mx-1 btn-soft-dark'} iconClasssName={'bx bx-x font-size-14 align-middle me-2'} name={'cancel'} onClick={invoiceCancel} />
                            </Col>
                        </Row>
                        <Template orderSummaryInfo={orderSummaryInfo} reRender={reRender} showEdit={showEdit} isCancel={isCancel} />
                    </Modal>
                    <Modal isOpen={isResendOpen} size="sm" centered>
                        <ResendToCustomer orderSummaryData={orderSummaryInfo} setShowModal={setIsResendOpen} isCancel={isCancel} encryptedOrderId={encryptedId} />
                    </Modal>
                    <Modal isOpen={showModal} size="md" centered >
                        <CancelOrder orderSummaryData={orderSummaryInfo} setShowModal={setShowModal} isCancel={isCancel} encryptedOrderId={encryptedId} />
                    </Modal>
                    <Offcanvas
                        isOpen={statusCanvas}
                        direction="end"
                        toggle={toggleStatusCanvas}
                    >
                        <OffcanvasHeader toggle={toggleStatusCanvas}>
                            <i className='fa fa-box-open text-dofy me-2 font-size-15'></i>
                            <span className='m-0 text-dofy fw-semibold'>Order Status</span>
                        </OffcanvasHeader>
                        <OffcanvasBody>
                            <SimpleBar className="h-100" ref={ref} >
                                <ul className="verti-timeline list-unstyled">
                                    {orderSummaryInfo?.OrderHistoryList?.map((item: IOrderHistory, index: any) => (
                                        <>
                                            {/* {item.StatusId == HelperConstant.StatusId.MODIFIED_PRICE ? <></> : */}
                                            <li className="event-list" key={index}>
                                                <div className="event-timeline-dot">
                                                    <i className={`bx font-size-18 ${index == 0 ? 'bxs-right-arrow-circle bx-fade-right text-dofy' : 'bx-right-arrow-circle'}`} />
                                                </div>
                                                <div className="d-flex flex-row">
                                                    <div className=''>
                                                        <p className='text-dofy font-size-12 m-0'>{moment(item.TransactionDate).format("DD-MMM-YYYY")} {moment(item.TransactionDate).format('LT')}
                                                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2 me-2" />
                                                        </p>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <p className='text-dofy fw-semibold font-size-12 m-0'>{item.StatusName} </p>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    {(item.StatusName === 'Scheduled' || item.StatusName === 'Re-Scheduled') ?
                                                        <div className="db-brandName m-0">
                                                            {item.AppointmentDate == null ? null :
                                                                <p className='my-1 font-size-13 text-dofy'>
                                                                    <i className='bx bxs-timer align-middle font-size-18 me-1'></i>
                                                                    {moment(item.AppointmentDate).format("DD-MMM-YYYY")} {moment(item.AppointmentDate).format('LT')}</p>}
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                    {item.Comments ?
                                                        <p className='my-1 font-size-12 text-success fw-semibold'>Comments: {item.Comments}</p> : null}
                                                </div>
                                                <div >
                                                    {item.AssigneeName ?
                                                        <>
                                                            <p className='fw-semibold font-size-12 m-0 text-primary'> <i className='bx bxs-user-check align-middle me-1 font-size-18'></i>  {item.AssigneeName}</p> </> : null}
                                                    <p className='text-dofy fw-bolder font-size-14 m-0'>{(item.Amount) ? currencyByCountry(toAmount(Math.ceil(item.Amount))) : ''}</p>
                                                </div>

                                            </li>
                                            {/* } */}
                                        </>
                                    ))}
                                </ul>
                            </SimpleBar>
                        </OffcanvasBody>
                    </Offcanvas>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AgentTicketView
